module.exports = __webpack_public_path__ + "img/jp_xhs_qrcode.9a67802.webp";